/* eslint-disable */

import Component from 'gia/Component'

export default class ListEvents extends Component {
  constructor(element) {
    super(element)
  }

  actions() {
    const mainElement = $(this.element)
    const delButton = mainElement.find('.delete-link')
    const delContainer = mainElement.find('.delete-popup')
    const delCancel = mainElement.find('#esc-delete')
    const delConfirm = mainElement.find('#confirm-delete')

    delButton.click(function(e) {
      e.preventDefault()
      delContainer.fadeToggle(200)
    })

    delCancel.click(function(e) {
      e.preventDefault()
      delContainer.fadeToggle(200)
    })

    delConfirm.click(function(e) {
      e.preventDefault()
      const lid = e.target.dataset.id
      $.ajax({
        url: window.location.origin + '/wp/wp-admin/admin-ajax.php',
        type: 'POST',
        data: {
          action: 'delete_list',
          lid: lid,
        },
        beforeSend: function() {},
        success: function(result) {
          window.location.replace(window.location.origin + '/lists')
        },
      })
    })

    //close window if you click elsewhere
    $(document).click(function(event) {
      var target = $(event.target)
      if (!target.closest(mainElement).length) {
        delContainer.fadeOut(150)
      }
    })
  }

  mount() {
    this.actions()
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/ListEvents.js